import { createContext, useContext } from 'react'

export const AuthContext = createContext({
  user: null,
  organizations: [],
  currentOrg: null,
  userRole: null,
  loading: true,
  isNewSignup: false,
  login: async () => {},
  register: async () => {},
  signOut: async () => {},
  setCurrentOrg: () => {},
  refreshOrganizations: async () => {},
  hasPermission: () => false,
  checkFeatureAccess: () => false,
})

export const useAuth = () => useContext(AuthContext)
